import { EncounterAmendmentReason } from "@/encounters/constants/encounter-amendment-reason";

/** Quilted CodeSystem for labor encounter Provenance activity (sign-off vs amend). */
export const LABOR_ENCOUNTER_PROVENANCE_ACTIVITY_SYSTEM =
  "http://quiltedhealth.com/fhir/CodeSystem/labor-encounter-provenance-activity";

/** Namespace for deterministic amend-completion Provenance resource ids (UUID v5). */
export const LABOR_ENCOUNTER_AMEND_COMPLETION_PROVENANCE_ID_NAMESPACE =
  "a1b2c3d4-e5f6-5789-a012-3456789abcde";

export enum LaborEncounterProvenanceActivityCode {
  InitialSignOff = "initial-sign-off",
  AmendCompletion = "amend-completion",
}

export const LABOR_ENCOUNTER_PROVENANCE_ACTIVITY_DISPLAY: Record<
  LaborEncounterProvenanceActivityCode,
  string
> = {
  [LaborEncounterProvenanceActivityCode.InitialSignOff]: "Labor encounter sign and lock",
  [LaborEncounterProvenanceActivityCode.AmendCompletion]: "Labor encounter amendment completion",
};

/** HL7 v3-ActReason codes used on encounter amend Provenance (aligned with encounter-form-answers bot). */
export enum LaborEncounterProvenanceReasonCode {
  ProviderCorrectionOfInformation = "FIXDATA",
  PatientRequestedChange = "PAT",
}

/** Maps encounter amend form reasons to HL7 v3 ActReason codes on Provenance.reason. */
export const ENCOUNTER_AMENDMENT_REASON_TO_PROVENANCE_REASON_CODE: Partial<
  Record<EncounterAmendmentReason, LaborEncounterProvenanceReasonCode>
> = {
  [EncounterAmendmentReason.ProviderCorrectionOfInformation]:
    LaborEncounterProvenanceReasonCode.ProviderCorrectionOfInformation,
  [EncounterAmendmentReason.ClientRequestedChange]:
    LaborEncounterProvenanceReasonCode.PatientRequestedChange,
};
